import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { BoardMeetingList } from "./board-meeting-list";
import { BoardMeetingView } from "./board-meeting-view";

export function BoardMeetings() {
  return (
    <>
      <Routes>
        <Route index element={<Navigate replace to="list" />} />
        <Route element={<BoardMeetingList />} path="/list/*" />
        <Route element={<BoardMeetingView />} path="/:id/*" />
      </Routes>
      <Outlet />
    </>
  );
}
